<template>
  <div>
    <slot :getDataField="getDataField" :getFilteredDataField="getFilteredDataField">
      <div class="single container-max page-content">
        <div class="row position-relative">

          <div class="col-12 col-md-6 mt-3">
            <slot name="image-carousel"></slot>
          </div>

          <div class="col-12 col-md-6 mt-3">
            <div v-stick-in-parent>
              <!-- START SINGLEITEM_DETAILS -->

              <div class="d-flex justify-content-between flex-column flex-md-row">
                <h1 class="h2 font-weight-bold d-inline-block pr-5 border-bot mb-2 mr-2" data-testing="item-name">
                  <span>
                    {{ currentVariation | itemName }}
                  </span>
                </h1>
                <div class="producertag h6 producer d-none text-muted" v-if="currentVariation.filter.hasManufacturer">
                  <img :src="currentVariation.item.manufacturer.logo" :alt="currentVariation.item.manufacturer.externalName" class="img-fluid" v-if="currentVariation.item.manufacturer.logo">
                  <span v-else v-html="currentVariation.item.manufacturer.externalName"></span>
                </div>
              </div>

              <slot name="tag-list"></slot>

              <p class="single-description"
                 v-if="isShortDescriptionActive && currentVariation.texts.shortDescription !== ''"
                 v-html="currentVariation.texts.shortDescription"></p>

              <div class="mb-5">
              <span class="articlenumber small text-muted d-block">
                <b>{{ $translate("Ceres::Template.singleItemNumber") }} </b>
                <span>{{ currentVariation.variation.number }}</span>
              </span>

                <span class="articlenumber small text-muted d-block" v-if="currentVariation.filter.hasManufacturer">
                  <b> Hersteller </b>
                  <span> {{ currentVariation.item.manufacturer.externalName }} </span>
                </span>

                <div class="fs-base-price articlenumber small text-muted d-block" v-if="currentVariation.unit"
                     :class="{ 'is-single-piece': currentVariation.unit && currentVariation.unit.content === 1 && currentVariation.unit.unitOfMeasurement === 'C62' }">
                  <div>
                    <b>{{ $translate("Ceres::Template.singleItemContent") }}</b>
                    <span>{{ currentVariation.unit.content | numberFormat }} </span>
                    <span>{{ currentVariation.unit.names.name }}</span>
                  </div>
                  <div v-if="currentVariation.variation.mayShowUnitPrice">
                    <b>{{ $translate("Ceres::Template.singleItemUnitPrice") }}</b>
                    <span class="base-price-value">
                      {{ variationGraduatedPrice.basePrice | specialOffer(currentVariation.prices, "basePrice") }}
                    </span>
                  </div>
                </div>

                <ul class="d-flex list-unstyled mb-0 mt-3 p-0 flex-wrap fs-bullets">
                  <li class="d-block mb-1 text-muted small" v-if="hasProp13Bullet" v-html="hasProp13Bullet"></li>
                  <li class="d-block mb-1 text-muted small" v-if="hasProp14Bullet" v-html="hasProp14Bullet"></li>
                  <li class="d-block mb-1 text-muted small" v-if="hasProp15Bullet" v-html="hasProp15Bullet"></li>
                  <li class="d-block mb-1 text-muted small" v-if="hasProp16Bullet" v-html="hasProp16Bullet"></li>
                  <li class="d-block mb-1 text-muted small" v-if="hasProp17Bullet" v-html="hasProp17Bullet"></li>
                </ul>

              </div>

              <!-- Variation -->
              <div class="mb-3" v-if="attributes.length || Object.keys(units).length">
                <variation-select></variation-select>
              </div>
              <!-- /Variation -->

              <!-- Item Bundle -->
              <item-bundle v-if="currentVariation.variation.bundleType === 'bundle'"
                           :bundle-type="currentVariation.variation.bundleType"
                           :bundle-components="currentVariation.bundleComponents"></item-bundle>
              <!-- /Item Bundle -->

              <slot name="before-price"></slot>

              <div v-if="currentVariation.filter.isSalable && variationGroupedProperties.length">
                <order-property-list></order-property-list>
              </div>

              <graduated-prices></graduated-prices>

              <item-price :show-cross-price="isRecommendedPriceActive"></item-price>


              <span class="vat small text-muted mb-2 ml-1d-inline-block">
                <template v-if="showNetPrices">{{ $translate("Ceres::Template.singleItemExclVAT") }}</template>
                <template v-else>{{ $translate("Ceres::Template.singleItemInclVAT") }}</template> {{ $translate("Ceres::Template.singleItemExclusive") }}
                <a v-if="hasShippingCostsCategoryId" data-toggle="modal" href="#shippingscosts"
                   :title="$translate('Ceres::Template.singleItemShippingCosts')">{{ $translate("Ceres::Template.singleItemShippingCosts") }}</a>
                <a v-else :title="$translate('Ceres::Template.singleItemShippingCosts')">{{ $translate("Ceres::Template.singleItemShippingCosts") }}</a>
              </span>

              <template v-if="currentVariation.prices.rrp != null">
                <div class="mt-0 mb-4 fs-saving" v-if="savingMoneyPercent > 0 && showSaving == 'true'">
                  <span class="text-muted">{{ $translate("meliorisVueTheme::Singleitem.savingMoney") }}</span>
                  <span class="text-danger"> -{{ savingMoneyPercent.toFixed(2) }}% ({{ savingMoney.toFixed(2) | currency(currentVariation.prices.default.currency) }})</span>
                </div>
              </template>

              <slot name="after-price"></slot>

              <span class="d-block">
                <item-availability></item-availability>
              </span>

              <div class="alert alert-warning fs-shortage p-3 my-3 d-inline-block"
                   v-if="currentVariation.stock.net < stockNumber && showStockWarning == 'true'">
                <p class="m-0">{{ $translate("meliorisVueTheme::Singleitem.shortage") }}</p>
              </div>

              <div class="my-3">
                <div class="w-100">
                  <slot name="before-add-to-basket"></slot>
                </div>

                <div v-if="currentVariation.item.itemType === 'set'" class="alert alert-info w-100">
                  {{ $translate("Ceres::Template.singleItemSetInfo") }}
                </div>
                <div v-else class="col-12 col-sm-7 col-md-12 col-lg-8 my-3 pl-0">
                  <add-to-basket :variation-id="currentVariation.variation.id"
                                 :is-salable="!!currentVariation.filter && currentVariation.filter.isSalable"
                                 :has-children="!!currentVariation.filter && currentVariation.filter.hasActiveChildren"
                                 :interval-quantity="currentVariation.variation.intervalOrderQuantity || 1"
                                 :minimum-quantity="currentVariation.variation.minimumOrderQuantity"
                                 :maximum-quantity="!!currentVariation.variation.maximumOrderQuantity && currentVariation.variation.maximumOrderQuantity > 0 ? currentVariation.variation.maximumOrderQuantity : null"
                                 :order-properties="currentVariation.properties.filter(function(prop) { return prop.property.isOderProperty })"
                                 :has-order-properties="currentVariation.hasOrderProperties"
                                 :has-required-order-property="currentVariation.hasRequiredOrderProperty"
                                 :use-large-scale="false"
                                 :show-quantity="true"
                                 :item-url="currentVariation | itemURL"
                                 :is-variation-selected="isVariationSelected && currentVariation.filter.isSalable"
                                 :has-price="currentVariation | hasItemDefaultPrice">
                  </add-to-basket>
                </div>

                <div class="w-100">
                  <slot name="after-add-to-basket"></slot>
                </div>
              </div>

              <div v-if="isWishListEnabled" class="row">
                <div class="col-12 singlewish">
                  <add-to-wish-list :variation-id="currentVariation.variation.id"></add-to-wish-list>
                </div>
              </div>

              <div class="fs-item-usps mt-md-3 mt-xl-5" v-if="showItemUsps == 'true'">
                <ul class="d-flex list-unstyled justify-content-between flex-wrap">
                  <li v-if="$translate('meliorisVueTheme::Singleitem.ItemUspText') != '' ">
                    <i class="fa" :class="$translate('meliorisVueTheme::Singleitem.ItemUspIcon')" aria-hidden="true">&nbsp;</i>
                    <span>{{ $translate("meliorisVueTheme::Singleitem.ItemUspText") }}</span>
                  </li>
                  <li v-if="$translate('meliorisVueTheme::Singleitem.ItemUsp2Text') != '' ">
                    <i class="fa " :class="$translate('meliorisVueTheme::Singleitem.ItemUsp2Icon')" aria-hidden="true">&nbsp;</i>
                    <span>{{ $translate("meliorisVueTheme::Singleitem.ItemUsp2Text") }}</span>
                  </li>
                  <li v-if="$translate('meliorisVueTheme::Singleitem.ItemUsp3Text') != '' ">
                    <i class="fa " :class="$translate('meliorisVueTheme::Singleitem.ItemUsp3Icon')" aria-hidden="true">&nbsp;</i>
                    <span>{{ $translate("meliorisVueTheme::Singleitem.ItemUsp3Text") }}</span>
                  </li>
                  <li v-if="$translate('meliorisVueTheme::Singleitem.ItemUsp4Text') != '' ">
                    <i class="fa " :class="$translate('meliorisVueTheme::Singleitem.ItemUsp4Icon')" aria-hidden="true">&nbsp;</i>
                    <span>{{ $translate("meliorisVueTheme::Singleitem.ItemUsp4Text") }}</span>
                  </li>
                </ul>
              </div>

              <!-- ./ITEM DETAIL -->

              <slot name="additional-content-after-add-to-basket"></slot>

              <slot name="additional-content-after-vat"></slot>
              <!-- END SINGLEITEM_DETAILS -->
            </div>
          </div>

          <div class="col-12 col-md-7 mt-3">
            <!-- ITEM DESCRIPTION -->
            <div class="my-5">
              <div class="fs-description mb-5" v-if="showDescription == 'true'">
                <p class="h3 font-weight-bold d-inline-block pr-5 border-bot mb-2">{{
                  $translate("Ceres::Template.singleItemDescription") }}</p>
                <div class="my-4" v-html="currentVariation.texts.description"></div>
              </div>

              <div class="fs-technicalData" v-if="showTechnicalDetails == 'true'">
                <p class="h3 font-weight-bold d-inline-block pr-5 border-bot mb-2">{{
                  $translate("Ceres::Template.singleItemTechnicalData") }}</p>
                <div class="my-4" v-html="currentVariation.texts.technicalData"></div>
              </div>
            </div>
            <slot name="add-detail-tabs"></slot>
            <slot name="add-detail-tabs-content"></slot>
            <!-- ./ITEM DESCRIPTION -->
          </div>

          <div class="col-12 col-md-5 mt-3 fs-bigimg">
            <img v-if="currentVariation.images.variation[1]" :src="currentVariation.images.variation[1].url"
                 :alt="currentVariation.texts.name1" class="img-fluid mt-5"/>
            <img v-else-if="currentVariation.images.variation[0]" :src="currentVariation.images.variation[0].url"
                 :alt="currentVariation.texts.name1" class="img-fluid mt-5"/>

            <div class="fs-details mt-5" v-if="showMoreDetails == 'true'">
              <p class="h3 font-weight-bold d-inline-block pr-5 border-bot mb-2">{{
                $translate("Ceres::Template.singleItemMoreDetails") }}</p>
              <div class="my-4">
                <table class="table table-striped table-hover table-sm">
                  <tbody>
                  <tr v-if="itemConfig.includes('item.id') || itemConfig.includes('all')">
                    <td>{{ $translate("Ceres::Template.singleItemId") }}</td>
                    <td>{{ currentVariation.item.id }}</td>
                  </tr>

                  <tr v-if="currentVariation.item.condition && currentVariation.item.condition.names.name !== '' && (itemConfig.includes('item.condition') || itemConfig.includes('all'))">
                    <td>{{ $translate("Ceres::Template.singleItemCondition") }}</td>
                    <td>{{ currentVariation.item.condition.names.name }}</td>
                  </tr>

                  <tr v-if="itemConfig.includes('item.age_rating') || itemConfig.includes('all')">
                    <td>{{ $translate("Ceres::Template.singleItemAge") }}</td>
                    <td>{{ currentVariation.item.ageRestriction | ageRestriction }}</td>
                  </tr>

                  <tr v-if="currentVariation.variation.externalId !== '' && (itemConfig.includes('item.external_id') || itemConfig.includes('all'))">
                    <td>{{ $translate("Ceres::Template.singleItemExternalVariationId") }}</td>
                    <td>{{ currentVariation.variation.externalId }}</td>
                  </tr>

                  <tr v-if="currentVariation.variation.model !== '' && (itemConfig.includes('item.variation_model') || itemConfig.includes('all'))">
                    <td>{{ $translate("Ceres::Template.singleItemModel") }}</td>
                    <td>{{ currentVariation.variation.model }}</td>
                  </tr>

                  <tr v-if="currentVariation.filter.hasManufacturer && currentVariation.item.manufacturer.externalName !== '' && (itemConfig.includes('item.manufacturer') || itemConfig.includes('all'))">
                    <td>{{ $translate("Ceres::Template.singleItemManufacturer") }}</td>
                    <td>{{ currentVariation.item.manufacturer.externalName }}</td>
                  </tr>

                  <tr v-if="currentVariation.item.producingCountry && currentVariation.item.producingCountry.names.name !== '' && (itemConfig.includes('item.producerCountry') || itemConfig.includes('all'))">
                    <td>{{ $translate("Ceres::Template.singleItemManufacturingCountry") }}</td>
                    <td>{{ currentVariation.item.producingCountry.names.name }}</td>
                  </tr>

                  <tr v-if="currentVariation.unit && (itemConfig.includes('item.variationBase_content') || itemConfig.includes('all'))">
                    <td>{{ $translate("Ceres::Template.singleItemContent") }}</td>
                    <td>{{ currentVariation.unit.content }} {{ currentVariation.unit.names.name }}</td>
                  </tr>

                  <tr v-if="currentVariation.variation.weightG !== '' && (itemConfig.includes('item.weightG') || itemConfig.includes('all'))">
                    <td>{{ $translate("Ceres::Template.singleItemWeight") }}</td>
                    <td>{{ currentVariation.variation.weightG }} g</td>
                  </tr>

                  <tr v-if="currentVariation.variation.weightNetG !== '' && (itemConfig.includes('item.weightNetG') || itemConfig.includes('all'))">
                    <td>{{ $translate("Ceres::Template.singleItemNetWeight") }}</td>
                    <td>{{ currentVariation.variation.weightNetG }} g</td>
                  </tr>

                  <tr v-if="itemConfig.includes('item.variation_dimensions') || itemConfig.includes('all')">
                    <td>{{ $translate("Ceres::Template.singleItemDimensions") }}</td>
                    <td>
                      <span>{{ currentVariation.variation.lengthMM }}</span>&times;
                      <!--
                      --><span>{{ currentVariation.variation.widthMM }}</span>&times;
                      <!--
                      --><span>{{ currentVariation.variation.heightMM }}</span>
                      mm
                    </td>
                  </tr>

                  <tr v-if="currentVariation.variation.customsTariffNumber !== '' && (itemConfig.includes('variation.customs_tariff_number') || itemConfig.includes('all'))">
                    <td>{{ $translate("Ceres::Template.singleItemCustomsTariffNumber") }}</td>
                    <td>{{ currentVariation.variation.customsTariffNumber }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <slot name="item-list-container"></slot>
        <slot name="feedback-container"></slot>
      </div>

      <div id="mobile-buybtn">
        <div class="d-flex d-sm-none py-2 px-3 align-items-center flex-wrap">
          <div class="vselect mr-3" v-if="attributes.length || Object.keys(units).length">
            <variation-select></variation-select>
          </div>
          <div class="mobile-add">
            <div v-if="currentVariation.item.itemType === 'set'" class="alert alert-info w-100">
              {{ $translate("Ceres::Template.singleItemSetInfo") }}
            </div>
            <div v-else class="col-12 col-sm-7 col-md-12 col-lg-8 mb-3 px-0">
              <add-to-basket :variation-id="currentVariation.variation.id"
                             :is-salable="!!currentVariation.filter && currentVariation.filter.isSalable"
                             :has-children="!!currentVariation.filter && currentVariation.filter.hasActiveChildren"
                             :interval-quantity="currentVariation.variation.intervalOrderQuantity || 1"
                             :minimum-quantity="currentVariation.variation.minimumOrderQuantity"
                             :maximum-quantity="!!currentVariation.variation.maximumOrderQuantity && currentVariation.variation.maximumOrderQuantity > 0 ? currentVariation.variation.maximumOrderQuantity : null"
                             :order-properties="currentVariation.properties.filter(function(prop) { return prop.property.isOderProperty })"
                             :has-order-properties="currentVariation.hasOrderProperties"
                             :has-required-order-property="currentVariation.hasRequiredOrderProperty"
                             :use-large-scale="false"
                             :show-quantity="true"
                             :item-url="currentVariation | itemURL"
                             :is-variation-selected="isVariationSelected && currentVariation.filter.isSalable"
                             :has-price="currentVariation | hasItemDefaultPrice">
              </add-to-basket>
            </div>
          </div>
        </div>
      </div>

    </slot>
  </div>
</template>




<script>
import {get} from "../../helper/get";
import {isNullOrUndefined} from "../../helper/utils";

export default {

  name: "single-item",

  props: {

    showCrossPrice:
    {
      type: Boolean,
      default: true
    },

    pleaseSelectOptionVariationId: {
      type: Number,
      default: 0
    },
    initPleaseSelectOption: {
      type: Boolean,
      default: false
    },
    showNetPrices: {
      type: Boolean,
      default: false
    },
    isWishListEnabled: {
      type: Boolean,
      default: false
    },
    itemId: {
      type: Number,
      required: true
    },
    afterKey: Object
  },

  jsonDataFields: [
    "itemData",
    "attributesData",
    "variations"
  ],

  provide() {
    return {
      itemId: this.$props.itemId
    }
  },

  computed: {
    itemConfig() {
      return App.config.item.itemData;
    },

    hasProp13Bullet() {
      if (this.currentVariation.variationProperties) {
        for (let vProperty of this.currentVariation.variationProperties) {
          for (let property of vProperty.properties) {
            if (property.id == 13 ) {
              return property.values.value;
            }
          }
        }
        return false;
      }
      return false;
    },
    hasProp14Bullet() {
      if (this.currentVariation.variationProperties) {
        for (let vProperty of this.currentVariation.variationProperties) {
          for (let property of vProperty.properties) {
            if (property.id == 14) {
              return property.values.value;
            }
          }
        }
        return false;
      }
      return false;
    },

    hasProp15Bullet() {
      if (this.currentVariation.variationProperties) {
        for (let vProperty of this.currentVariation.variationProperties) {
          for (let property of vProperty.properties) {
            if (property.id == 15) {
              return property.values.value;
            }
          }
        }
        return false;
      }
      return false;
    },

    hasProp16Bullet() {
      if (this.currentVariation.variationProperties) {
        for (let vProperty of this.currentVariation.variationProperties) {
          for (let property of vProperty.properties) {
            if (property.id == 16) {
              return property.values.value;
            }
          }
        }
        return false;
      }
      return false;
    },
    hasProp17Bullet() {
      if (this.currentVariation.variationProperties) {
        for (let vProperty of this.currentVariation.variationProperties) {
          for (let property of vProperty.properties) {
            if (property.id == 17) {
              return property.values.value;
            }
          }
        }
        return false;
      }
      return false;
    },



    showStockWarning() {
      return App.themeConfig.showStockWarning
    },
    stockNumber() {
      return App.themeConfig.stockNumber
    },
    showSaving() {
      return App.themeConfig.showSaving
    },
    savingMoneyPercent() {
      return (this.currentVariation.prices.rrp.unitPrice.value - this.currentVariation.prices.default.price.value) / this.currentVariation.prices.rrp.unitPrice.value * 100;
    },
    savingMoney() {
      return (this.currentVariation.prices.rrp.unitPrice.value - this.currentVariation.prices.default.price.value);
    },
    showDescription() {
      return App.themeConfig.showDescription
    },
    showItemUsps() {
      return App.themeConfig.showItemUsps
    },
    showTechnicalDetails() {
      return App.themeConfig.showTechnicalDetails
    },
    showMoreDetails() {
      return App.themeConfig.showMoreDetails
    },

    variationGraduatedPrice() {
      return this.$store.getters[`${this.itemId}/variationGraduatedPrice`];
    },

    isDescriptionTabActive() {
      return (App.config.item.itemData.includes("item.description") || App.config.item.itemData.includes("all")) &&
          !!this.currentVariation.texts.description.length;
    },

    isRecommendedPriceActive() {
      return App.config.item.itemData.includes("item.recommendedPrice") || App.config.item.itemData.includes("all");
    },

    isShortDescriptionActive() {
      return App.config.item.itemData.includes("item.shortDescription") || App.config.item.itemData.includes("all");
    },

    hasShippingCostsCategoryId() {
      return App.config.global.shippingCostsCategoryId > 0;
    },

    isTechnicalDataTabActive() {
      return (App.config.item.itemData.includes("item.technical_data") || App.config.item.itemData.includes("all")) &&
          !!this.currentVariation.texts.technicalData.length;
    },

    variationGroupedProperties() {
      return this.$store.getters[`${this.itemId}/variationGroupedProperties`];
    },

    variationMissingProperties() {
      return this.$store.getters[`${this.itemId}/variationMissingProperties`];
    },

    currentVariation() {
      return get(this.$store.state, `items[${this.itemId}].variation.documents[0].data`);
    },

    isVariationSelected() {
      return get(this.$store.state, `items[${this.itemId}].variationSelect.isVariationSelected`);
    },

    attributes() {
      return get(this.$store.state, `items[${this.itemId}].variationSelect.attributes`);
    },

    units() {
      return get(this.$store.state, `items[${this.itemId}].variationSelect.units`);
    },

    isItemSet() {
      return this.$store.state.items.isItemSet;
    }
  },

  created() {
    this.$store.dispatch("initVariation", this.itemData);
    this.$store.commit(`${this.itemId}/setPleaseSelectVariationId`, this.pleaseSelectOptionVariationId);
  },

  mounted() {
    this.$nextTick(() => {
      this.$store.dispatch(`${this.itemId}/variationSelect/setVariationSelect`, {
        itemId: this.itemId,
        attributes: this.attributesData,
        variations: this.variations,
        initialVariationId: this.currentVariation.variation.id,
        isPleaseSelectOption: this.initPleaseSelectOption,
        afterKey: this.afterKey
      });

      if (this.isItemSet) {
        this.$store.dispatch("initSetComponents", this.itemData);
      }
    })

// listen for variation change to hydrate all children lazy-hydrate components
    document.addEventListener("onVariationChanged", () => this.hydrateChildren(this.$children));
  },

  methods: {
    getDataField(field) {
      return get(this.currentVariation, field);
    },

    getFilteredDataField(field, filter) {
      if (!isNullOrUndefined(this.$options.filters[filter])) {
        return this.$options.filters[filter](this.getDataField(field));
      }
      return this.getDataField(field);
    },

// iterate recursively the children components and call their hydrate method, if it is a lazy-hydrate component
    hydrateChildren(nodes) {
      nodes.forEach(component => {
        if (component.$options.name === "lazy-hydrate") {
          component.hydrate();
        } else if (component.$children.length) {
          this.hydrateChildren(component.$children);
        }
      })
    }
  }
}
</script>
